var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.$t('transactions.title')))]),_vm._v(" "),_c('div',{staticClass:"back"},[_c('router-link',{attrs:{"to":{name: 'MarketPlace'}}},[_c('font-awesome-icon',{attrs:{"icon":"chevron-left"}}),_vm._v(" "+_vm._s(_vm.$t('global.back'))+"\n        ")],1)],1),_vm._v(" "),_c('b-table',{staticClass:"mt-4",attrs:{"striped":"","hover":"","items":_vm.getItems(),"fields":_vm.getFields()}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36a5aac5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/Transactions.vue
// module id = 1107
// module chunks = 0